/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatchOrganizationCombosRequestInnerAllOfSchedulesInner } from './PatchOrganizationCombosRequestInnerAllOfSchedulesInner';
import {
    PatchOrganizationCombosRequestInnerAllOfSchedulesInnerFromJSON,
    PatchOrganizationCombosRequestInnerAllOfSchedulesInnerFromJSONTyped,
    PatchOrganizationCombosRequestInnerAllOfSchedulesInnerToJSON,
    PatchOrganizationCombosRequestInnerAllOfSchedulesInnerToJSONTyped,
} from './PatchOrganizationCombosRequestInnerAllOfSchedulesInner';
import type { PatchOrganizationCombosRequestInnerAllOfCategoriesInner } from './PatchOrganizationCombosRequestInnerAllOfCategoriesInner';
import {
    PatchOrganizationCombosRequestInnerAllOfCategoriesInnerFromJSON,
    PatchOrganizationCombosRequestInnerAllOfCategoriesInnerFromJSONTyped,
    PatchOrganizationCombosRequestInnerAllOfCategoriesInnerToJSON,
    PatchOrganizationCombosRequestInnerAllOfCategoriesInnerToJSONTyped,
} from './PatchOrganizationCombosRequestInnerAllOfCategoriesInner';

/**
 * 
 * @export
 * @interface UpdateOrganizationComboRequest
 */
export interface UpdateOrganizationComboRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationComboRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationComboRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateOrganizationComboRequest
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationComboRequest
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationComboRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationComboRequest
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganizationComboRequest
     */
    hasSchedule: boolean;
    /**
     * 
     * @type {Array<PatchOrganizationCombosRequestInnerAllOfCategoriesInner>}
     * @memberof UpdateOrganizationComboRequest
     */
    categories: Array<PatchOrganizationCombosRequestInnerAllOfCategoriesInner>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganizationComboRequest
     */
    enabled: boolean;
    /**
     * 
     * @type {Array<PatchOrganizationCombosRequestInnerAllOfSchedulesInner>}
     * @memberof UpdateOrganizationComboRequest
     */
    schedules?: Array<PatchOrganizationCombosRequestInnerAllOfSchedulesInner>;
}

/**
 * Check if a given object implements the UpdateOrganizationComboRequest interface.
 */
export function instanceOfUpdateOrganizationComboRequest(value: object): value is UpdateOrganizationComboRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('hasSchedule' in value) || value['hasSchedule'] === undefined) return false;
    if (!('categories' in value) || value['categories'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function UpdateOrganizationComboRequestFromJSON(json: any): UpdateOrganizationComboRequest {
    return UpdateOrganizationComboRequestFromJSONTyped(json, false);
}

export function UpdateOrganizationComboRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOrganizationComboRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'price': json['price'],
        'color': json['color'] == null ? undefined : json['color'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'hasSchedule': json['hasSchedule'],
        'categories': ((json['categories'] as Array<any>).map(PatchOrganizationCombosRequestInnerAllOfCategoriesInnerFromJSON)),
        'enabled': json['enabled'],
        'schedules': json['schedules'] == null ? undefined : ((json['schedules'] as Array<any>).map(PatchOrganizationCombosRequestInnerAllOfSchedulesInnerFromJSON)),
    };
}

export function UpdateOrganizationComboRequestToJSON(json: any): UpdateOrganizationComboRequest {
    return UpdateOrganizationComboRequestToJSONTyped(json, false);
}

export function UpdateOrganizationComboRequestToJSONTyped(value?: UpdateOrganizationComboRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'price': value['price'],
        'color': value['color'],
        'description': value['description'],
        'imageId': value['imageId'],
        'hasSchedule': value['hasSchedule'],
        'categories': ((value['categories'] as Array<any>).map(PatchOrganizationCombosRequestInnerAllOfCategoriesInnerToJSON)),
        'enabled': value['enabled'],
        'schedules': value['schedules'] == null ? undefined : ((value['schedules'] as Array<any>).map(PatchOrganizationCombosRequestInnerAllOfSchedulesInnerToJSON)),
    };
}

